export default {
    lg: [
      {
        w: 8,
        h: 2,
        x: 0,
        y: 0,
        i: "recentServices"
      },
      {
        w: 4,
        h: 2,
        x: 8,
        y: 0,
        i: "csmsHealth"
      },
      {
        w: 5,
        h: 2,
        x: 0,
        y: 0,
        i: "favorites"
      },
      {
        w: 3,
        h: 2,
        x: 5,
        y: 0,
        i: "blogRecentPosts"
      },
      {
        w: 4,
        h: 2,
        x: 9,
        y: 2,
        i: "vodUsage"
      },
      {
        w: 3,
        h: 2,
        x: 3,
        y: 2,
        i: "vodConversionStatus"
      }
    ],
    md: [
      {
        w: 6,
        h: 2,
        x: 0,
        y: 0,
        i: "recentServices"
      },
      {
        w: 4,
        h: 2,
        x: 6,
        y: 0,
        i: "csmsHealth"
      },
      {
        w: 3,
        h: 2,
        x: 0,
        y: 0,
        i: "favorites"
      },
      {
        w: 3,
        h: 2,
        x: 3,
        y: 0,
        i: "blogRecentPosts"
      },
      {
        w: 4,
        h: 2,
        x: 6,
        y: 2,
        i: "vodUsage"
      },
      {
        w: 3,
        h: 2,
        x: 3,
        y: 2,
        i: "vodConversionStatus"
      }
    ],
    sm: [
      {
        w: 6,
        h: 2,
        x: 0,
        y: 0,
        i: "recentServices"
      },
      {
        w: 3,
        h: 2,
        x: 0,
        y: 0,
        i: "csmsHealth"
      },
      {
        w: 3,
        h: 2,
        x: 3,
        y: 0,
        i: "favorites"
      },
      {
        w: 3,
        h: 2,
        x: 0,
        y: 0,
        i: "blogRecentPosts"
      },
      {
        w: 3,
        h: 2,
        x: 3,
        y: 2,
        i: "vodUsage"
      },
      {
        w: 3,
        h: 2,
        x: 0,
        y: 2,
        i: "vodConversionStatus"
      }
    ],
    xs: [
      {
        w: 4,
        h: 2,
        x: 0,
        y: 0,
        i: "recentServices"
      },
      {
        w: 4,
        h: 2,
        x: 0,
        y: 0,
        i: "csmsHealth"
      },
      {
        w: 4,
        h: 2,
        x: 0,
        y: 0,
        i: "favorites"
      },
      {
        w: 4,
        h: 2,
        x: 0,
        y: 0,
        i: "blogRecentPosts"
      },
      {
        w: 4,
        h: 2,
        x: 0,
        y: 2,
        i: "vodUsage"
      },
      {
        w: 4,
        h: 2,
        x: 0,
        y: 2,
        i: "vodConversionStatus"
      }
    ],
    xxs: [
      {
        w: 2,
        h: 2,
        x: 0,
        y: 0,
        i: "recentServices"
      },
      {
        w: 2,
        h: 2,
        x: 0,
        y: 2,
        i: "csmsHealth"
      },
      {
        w: 2,
        h: 2,
        x: 0,
        y: 4,
        i: "favorites"
      },
      {
        w: 2,
        h: 2,
        x: 0,
        y: 6,
        i: "blogRecentPosts"
      },
      {
        w: 2,
        h: 2,
        x: 0,
        y: 8,
        i: "vodUsage"
      },
      {
        w: 2,
        h: 2,
        x: 0,
        y: 10,
        i: "vodConversionStatus"
      }
    ]
  };
